@if (!expanded) {
    <dx-popup [hideOnOutsideClick]="true"
              [dragEnabled]="false"
              [showTitle]="false"
              [visible]="visible"
              (onContentReady)="onContentReady($event)"
              [height]="resizedHeight ? resizedHeight + 25 : resizedHeight"
              [width]="resizedWidth"
              (onHiding)="closePopup()"
              shadingColor="rgba(0, 0, 0, 0.5)">
        <div *dxTemplate="let data of 'content'"
             class="d-flex flex-column">
            <ng-container *ngTemplateOutlet="imgView"></ng-container>
        </div>
    </dx-popup>
}

@if (expanded) {
    <div id="imagePopup__expanded"
         class="dx-overlay-wrapper dx-overlay-modal dx-overlay-shader d-flex flex-column"
         (click)="closePopup()">
        <ng-container *ngTemplateOutlet="imgView"></ng-container>
    </div>
}

<ng-template #imgView>
    <button class="btn-close-popup align-self-end"
            data-test="fullscreen-dialog-close"
            (click)="closePopup()">
        <i class="fal fa-times"></i>
    </button>
    <div class="h-100 w-100"
         [ngClass]="{ 'can-expand': canExpand, expanded: expanded }"
         data-test="fullscreen-dialog-content"
         #scroller>
        @switch (isFrame) {
            @case (false) {
                <img [src]="src"
                     alt=""
                     (load)="triggerResize$.next()"
                     #content
                     (click)="toggleExpandImage($event)" />
            }
            @case (true) {
                <iframe [src]="src"
                        #content
                        frameborder="0"
                        allowfullscreen></iframe>
            }
        }
    </div>
</ng-template>
